import {
  GET_MEMBERSHIPS_BIN_MONTHLY_STATS,
  GET_MEMBERSHIPS_BIN_MONTHLY_STATS_SUCCESS,
  GET_MEMBERSHIPS_BIN_MONTHLY_STATS_ERROR,
  GET_MEMBERSHIPS_BIN_MONTHLY_STATS_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetMembershipsBinMonthlyStats = (state = initialState, action) => {
  switch (action.type) {
    case GET_MEMBERSHIPS_BIN_MONTHLY_STATS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_MEMBERSHIPS_BIN_MONTHLY_STATS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_MEMBERSHIPS_BIN_MONTHLY_STATS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_MEMBERSHIPS_BIN_MONTHLY_STATS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetMembershipsBinMonthlyStats;
